"use strict";
angular.module("internal.exams").controller("InternalExamPermissionLocations", [
    "$scope",
    "EXLocation",
    "$rootScope",
    "Resource",
    "Cache",
    function ($scope, EXLocation, $rootScope, Resource, Cache) {
        $scope.locations = [];
        $scope.locationCities = [];
        $scope.loading = true;
        EXLocation.get().then(function (Locations) {
            Locations = Locations.records;
            var citiesList = [];
            Locations.forEach(function (location) {
                if (location.sessionCount == null) {
                    location.sessionCount = 0;
                }
                if (location.municipality != null && !citiesList.includes(location.municipality)) {
                    citiesList.push(location.municipality);
                }
            });
            citiesList.forEach(function (city) {
                $scope.locationCities.push({ id: city, name: city });
            });
            $scope.locations = Locations;
            $scope.loading = false;
        });
        $scope.columns = [{
            label: "Name",
            field: "name",
            link: {
                state: "internal.exams.administrative.location",
                params: [{
                    name: "examLocationID",
                    field: "id"
                }]
            }
        },
        {
            label: "Active",
            field: "activeStatus",
            type: "yesno"
        },
        {
            label: "Address",
            field: "streetCombined"
        },
        {
            label: "City",
            field: "municipality"
        },
        {
            label: "Exam Session Count",
            field: "sessionCount"
        },
        {
            label: "Last Modified",
            field: "modifiedOn",
            type: "datetime"
        },
        {
            label: "Modified By",
            field: "modifiedByFullName"
        }];
        $scope.filters = [{
            name: "Active",
            field: "activeStatus",
            options: [{
                name: "Not Active",
                id: false
            }, {
                name: "Active",
                id: true
            }]
        },
        {
            name: "City",
            field: "municipality",
            options: $scope.locationCities
        }];
    }
]);